import Vue from 'vue'
import App from './App.vue'
import Api from '@/api/'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCcVisa, faCcMastercard, faCcDiscover, faCcJcb, faCcDinersClub, faCcAmex } from '@fortawesome/free-brands-svg-icons'
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import moment from 'moment'

window.bugsnagClient = Bugsnag
Bugsnag.start({
  apiKey: '09b86425975e20a293368f9a934ab9e1',
  plugins: [new BugsnagPluginVue()]
})

library.add(faPhone)
library.add(faEnvelope)
library.add(faCcVisa)
library.add(faCcMastercard)
library.add(faCcJcb)
library.add(faCcDiscover)
library.add(faCcDinersClub)
library.add(faCcAmex)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.mixin({
  methods: {
    $currency (value) {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value)
    },

    $moment (date, utc = false) {
      if (utc) {
        return moment.utc(date)
      }
      return moment(date)
    },

    $momentDate (date) {
      return this.$moment(date).format('Do MMM YYYY')
    },

    $momentDateTime (date, utc = false) {
      return this.$moment(date, utc).format('YYYY-MM-DD HH:mm:SS')
    },

    $momentDateTimeHuman (date, utc = false) {
      return this.$moment(date, utc).format('Do MMM YYYY - HH:mm:SS')
    }
  }
})

Vue.use(Api, {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  havebikeClientId: process.env.VUE_APP_CLIENT_ID
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
